export {
    LEVEL_ERROR as FLOW_VALIDATION_ERROR,
    LEVEL_WARN as FLOW_VALIDATION_WARN,
    GENERIC_VALIDATION as FLOW_GENERIC_VALIDATION,
    FIELD_VALIDATION as FLOW_FIELD_VALIDATION,
    UNDERWRITING_ISSUE as FLOW_UNDERWRITING_ISSUE
} from 'edge/platform/flow/validation/FlowValidationService';


const fn = (StateUtils) => {
    function withValidationService(callback, ifNoValidationService) {
        const { flowModel } = StateUtils.activeDataForState(true);
        if (flowModel) {
            return callback(flowModel.currentStep.validationService);
        }

        // when the flow has not been initalized yet
        return ifNoValidationService;
    }

    function isActive() {
        return withValidationService(validationService => validationService.isActive(), false);
    }

    function reportErrorsAndWarnings(errorsAndWarnings = {}) {
        withValidationService(validationService => validationService.reportErrorsAndWarnings(errorsAndWarnings));
    }
    function getDisplayableErrors({types, includeHidden = false, includeErrorsOnCurrentStep = false} = {}) {
        return withValidationService(validationService => validationService.getDisplayableErrors({types, includeHidden, includeErrorsOnCurrentStep}), []);
    }

    function getInvalidWizardSteps({types, level} = {}) {
        return withValidationService(validationService => validationService.getInvalidWizardSteps({types, level}), []);
    }

    function getFirstInvalidStep({types, level} = {}) {
        return withValidationService(validationService => validationService.getFirstInvalidStep({types, level}), undefined);
    }

    function acknowledgeAllWarnings({type} = {}) {
        withValidationService(validationService => validationService.acknowledgeAllWarnings({type}));
    }

    function acknowledgeWarning(id) {
        withValidationService(validationService => validationService.acknowledgeWarning(id));
    }

    function approveUnderwritingIssue(id) {
        withValidationService(validationService => validationService.approveUnderwritingIssue(id));
    }

    function subscribeToChanges(subscriber) {
        return withValidationService(validationService => validationService.subscribeToChanges(subscriber), () => {});
    }

    function unsubscribeFromChanges(subscriber) {
        withValidationService(validationService => validationService.unsubscribeFromChanges(subscriber));
    }

    return {
        isActive,
        reportErrorsAndWarnings,
        getDisplayableErrors,
        getInvalidWizardSteps,
        getFirstInvalidStep,
        acknowledgeAllWarnings,
        acknowledgeWarning,
        approveUnderwritingIssue,
        subscribeToChanges,
        unsubscribeFromChanges
    };
};

fn.$inject = ['StateUtils'];

export default fn;

